import { DeliveryDetail } from '../../../../app/models/DeliveryDetail';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';

interface Props {
    details: Array<{
        key: string;
        product: string;
        unit: string;
        total_quantity: number;
        lots: DeliveryDetail[];
    }>;
    loading?: boolean;
    viewLots?: (rowKey: string) => void;
    destroyGroup?: (rowKey: string) => void;
}

const DeliveryDetailDataTable = ({ details, loading = false, viewLots, destroyGroup }: Props) => {
    const columns = [
        {
            name: 'Posición',
            selector: (_row: any, index: number) => index + 1,
            sortable: false,
            width: '90px',
            cell: (_row: any, index: number) => <span>{index + 1}</span>
        },
        {
            name: 'Producto',
            selector: (row: any) => row.product,
            sortable: false,
            cell: (row: any) => <span>{row.product || '-'}</span>
        },
        {
            name: 'Cantidad',
            selector: (row: any) => row.total_quantity,
            sortable: false,
            width: '120px',
            cell: (row: any) => <span>{row.total_quantity}</span>
        },
        {
            name: 'Unidad',
            selector: (row: any) => row.unit,
            sortable: false,
            width: '120px',
            cell: (row: any) => <span>{row.unit || ''}</span>
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.key,
            sortable: false,
            width: '150px',
            cell: (row: any) => (
                <div className="">
                    {viewLots && (
                        <ButtonTableAction
                            callbackFunction={() => viewLots(row.key)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-primary'}
                            errorMessage={'No se puede visualizar.'}
                            title={'Visualizar'}
                        />
                    )}
                    {destroyGroup && (
                        <ButtonTableAction
                            callbackFunction={() => destroyGroup(row.key)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <DefaultDataTable
            columns={columns}
            data={details}
            progressPending={loading}
            paginationTotalRows={0}
            filter={{ page: 1, per_page: 1000, sort: '', order: '' }}
            setFilter={() => undefined}
            pagination={false}
        />
    );
};

export default DeliveryDetailDataTable;

